import React from "react";

import DataTable from "../../../DataTable";

import useOutputReportStore from "../../../../store/OutputReport.store";
import { getOutputType } from "../../../../utils/helpers/dataTable";
import { dataTableCopy } from "../../../../utils/resources/dataTableCopy";

const CouponCashFlowDataTable = () => {
  const reportName = "Cash Flow Profile"; // Refer to corresponding API Key
  const data = useOutputReportStore((state) => state.data);
  const types = useOutputReportStore((state) => state.types);
  const { reportType, assetType } = getOutputType(data);
  const reportData = data[reportName];
  const reportFormatting = types?.[reportName];

  // Custom processing of rows labels
  const firstObjectKey = Object.keys(reportData)[0];
  if (!firstObjectKey) return null;

  const dateKeys = reportData[firstObjectKey].Dates;
  const rows = dateKeys.map((key) => ({
    label: key.date.toUpperCase(),
    key: key.date,
  }));

  // Custom processing of columns
  const columns = Object.entries(reportData).map((data) => ({
    columnTitle: data[0],
    Total: data[1].Total,
    ...data[1].Dates.reduce(
      (acc, curr) => ({
        ...acc,
        [curr.date]: curr.value,
      }),
      {}
    ),
  }));

  // Custom processing of data format type
  const formatTypes = Object.keys(reportFormatting).reduce(
    (previous, key) => ({
      ...previous,
      [key]: reportFormatting[key].Dates,
    }),
    {}
  );

  const footnoteTransition = (
    <>
      {dataTableCopy.proposalNotMaintained}
      <br />
      [1]{dataTableCopy.couponCashFlowCalculated}
    </>
  );

  const footnoteMuniLadder = (
    <>
      [1]{dataTableCopy.existingPortfolioInformation}
      <br />
      [2]{dataTableCopy.modelAndTransitionAnalysis}
    </>
  );

  const footnoteCash = (
    <>
      {dataTableCopy.unlessOtherwiseStated}
      <br />
      [1]{dataTableCopy.targetPortfolios}
    </>
  );

  const footnotes = {
    transition: {
      muni: footnoteMuniLadder,
      corp: footnoteTransition,
      treasury: footnoteTransition,
    },
    cash: {
      muni: footnoteCash,
      corp: footnoteCash,
      treasury: footnoteCash,
      tbill: "",
    },
  };

  return (
    <DataTable
      reportType={reportType}
      name="couponCashFlow"
      variation="stylized"
      tableCaption={`${reportName} Data Table`}
      tableRowHeaderKey="Month"
      tableRowKeys={[
        ...rows,
        {
          label: "Total",
          key: "Total",
        },
      ]}
      tableColumns={columns}
      tableDataTypes={formatTypes}
      formatCellDataBy="column"
      footnote={footnotes[reportType][assetType]}
    />
  );
};

export default CouponCashFlowDataTable;
